import { Container } from "@material-ui/core";
import { IPaymentLinkResponse } from "models/paymentLink/IPaymentLinkResponse";
import React, { FC, useRef } from "react";
import ApplePayButton from "./ApplePayButton/ApplePayButton";
import ApplePayForm from "./ApplePayForm";
import styles from "./ApplePay.module.scss";
import { UseApplePay } from "./UseApplePay";
import { useUi } from "context/ui/UIContext";
import { ReactComponent as Check } from "assets/icons/check.svg";
import { IDigitalWalletPaymentRequest } from "models/digitalWallet/IDigitalWallet";
import { moneyMaskNumber } from "utils/mask/money";

export interface IApplePay {
	paymentLink: IPaymentLinkResponse;
}

const ApplePay: FC<IApplePay> = ({ paymentLink }) => {
	const {
		owner,
		setOwner,
		approved,
		errors,
		address,
		setAddress,
		onClickSend,
		validateForm,
	} = UseApplePay(paymentLink);

	const { isMobile } = useUi();
	const formRef = useRef<HTMLDivElement>(null);

	if (approved.length) {
		return (
			<div className={styles.approved}>
				<Check />
				<p>
					{paymentLink.successMessage
						? paymentLink.successMessage
						: "Transação aprovada!"}
				</p>
				<p>
					Valor pago: <b> {moneyMaskNumber(Number(paymentLink.price))}</b>
				</p>
				<p>
					Pedido: <b> {approved}</b>
				</p>
			</div>
		);
	}

	return (
		<Container maxWidth="md">
			<div
				id={styles.ApplePay}
				style={{ marginBottom: isMobile ? 16 : undefined }}
			>
				<div className={styles.title}>
					Realize o pagamento através do Apple Pay
				</div>

				<div
					className={styles.container}
					ref={formRef}
					style={{ height: isMobile ? "auto" : undefined }}
				>
					<ApplePayForm
						owner={owner}
						setOwner={setOwner}
						formRef={formRef}
						errors={errors}
						address={address}
						setAddress={setAddress}
					/>
				</div>

				<div className={styles.applePayButtonContainer}>
					<ApplePayButton
						amount={paymentLink.price} 
						onSubmit={async (payload: IDigitalWalletPaymentRequest) => { await onClickSend(payload); return }}
						validateForm={validateForm}
					/>
				</div>
			</div>
		</Container>
	);
};

export default ApplePay;
